import React, {Fragment, useEffect, useState} from "react";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import men_user from "./assets/images/agent.png";
import cx from "classnames";
import { Button } from "reactstrap";
import ImportModel from "./ImportModel";
import { checkIsAgencyView, getSessionValue } from "../../Common/Appcommon";
import Loading from "../../Common/Loading";

const AIAgentsSideBar = (props) => {
    let {formData, curRowId, formname, fieldNames, onAgentChange,handleCreateModal,allowNewConfig, allowCreateAgents,showButtonLoading = false,getButtonFromImport = undefined, voiceList } = props;
    const [formdata, setFormdata] = useState([]);
    useEffect(() => {
        setFormdata(props.formData)
    }, [props]);

    const handleModal = () => {
        handleCreateModal();
    }

    let isSubAccountView = getSessionValue("isSubAccountView") === "true";
    const isAgencyView = checkIsAgencyView();

    return(
        <Fragment>
            <div className='agent-bar'>
                <div className='agent-container'>
                    {(isAgencyView || (allowNewConfig && allowCreateAgents)) &&(
                        <div className='data-row-container-btn'>
                            <div className="d-flex">
                                <Button onClick={handleModal} className={`agent-list mb-2 cursor-pointer agent-create-btn ${isSubAccountView && isAgencyView ? 'w-50' : ''}`} type="submit">
                                    <span className="agent-create-btn-spn-1 justify-center">
                                        <i class="fi fi-br-plus"></i>Add Agent
                                    </span>
                                </Button>
                                {isSubAccountView && isAgencyView && (
                                    <div className="w-50 ps-2">
                                        {getButtonFromImport && getButtonFromImport(showButtonLoading)}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={`data-row-container ${isAgencyView || allowCreateAgents ? 'agent-manual-div' : 'pt-3'}`}>
                        <div className='agent'>
                            {
                                formData.length > 0 && formData.map((rowdata, index) => {
                                    let voiceId = rowdata["voice_id"];
                                    let voice = voiceList.flat().find(voice => voice.Voice_Id === voiceId);
                                    let agent_icon = voice?.["Icon"];
                                    let id = rowdata[formname+'_id'] !== undefined ? rowdata[formname+'_id'] : "";
                                    let Name = rowdata[fieldNames['Agent_Name']] !== undefined ? rowdata[fieldNames['Agent_Name']] : ""; // it was modifyed
                                    //let Gender = rowdata['Gender'] !== undefined ? rowdata['Gender'] : "";
                                    let icon = men_user;
                                    // if (Gender.toLowerCase() === "female") {
                                    //     icon = women_user;
                                    // }
                                    if(Name === ""){
                                        Name = "AI Agent";
                                    }
                                    return (
                                        <div className={cx("agent-list mb-2", {"selected-bg" : curRowId === id})} onClick={() => {onAgentChange(rowdata, index) }}>
                                            <div className='user-pic'>
                                                <span className='d-flex'>
                                                    {(agent_icon?<img src={agent_icon}></img>:<i className="fi fi-ss-user-headset"></i>)}
                                                </span>
                                            </div>
                                            <div className='user-detail-wrap agent-header-div'>
                                                <div className='user-name-Name-time-wrap'>
                                                    <div className='user-name-Name-wrap agent-header-div agent-header-wid'>
                                                        <span className='user-name'>
                                                            {Name}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                (formData === undefined || formData.length === 0) && <div>No Calls Found</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AIAgentsSideBar);